<template>

</template>

<script>
export default {
  name: "Out",
  beforeRouteEnter(to,from,next){
    // console.log(123);
    next((vm)=>{
      vm.setlogout();
      //vm.getUserMenus();
    });
  },
  methods:{

  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/Out.vue